module.exports = __webpack_public_path__ + "static/media/dqcircle.f5ffa30c.png";